import {
	Component,
	Input,
	ViewEncapsulation,
	forwardRef,
	Output,
	EventEmitter,
	ElementRef,
	ViewChild,
	OnDestroy,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { IdService, FormControlBase } from '../../shared/index';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'rbc-toggle',
	templateUrl: './button-toggle.component.html',
	styleUrls: ['./button-toggle.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => ButtonToggleComponent)
		}
	]
})
export class ButtonToggleComponent extends FormControlBase<string> implements OnDestroy, OnChanges {
	@Input() id: string;
	// @Input() checked: string;
	@Input() disabled: boolean;
	@Input() name: string;
	@Input() value: string;
	@Input() model: string;

	@Output() radioUpdate = new EventEmitter();

	@ViewChild('control') control: ElementRef;

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		if (changes && changes.model) {
			this.writeValue(changes.model.currentValue);
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	setModel(value: string) {
		this.innerValue = value;
		this.changed(value);
	}

	updateSelected() {
		this.radioUpdate.emit({
			name: this.name,
			checked: this.innerValue
		});
	}

	checkSelected() {
		if (this.innerValue === this.value) {
			return true;
		}
		return false;
	}

	removeFocus() {
		this.control.nativeElement.blur();
		this.touch();
	}
}
